import React, { useMemo, useEffect, useState } from "react"

import { useNavigate } from "react-router-dom"

import AddDocumentMaster from "./AddDocumentMaster"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const AllDocumentMaster = ({ module_id }) => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getDocuments = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(`/document-master`)
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getDocuments()
  }, [])

  return (
    <>
      {loading && <Loader />}
      <TableComponent
        table_data={table_data}
        settable_data={settable_data}
        module_id={module_id}
      />
    </>
  )
}

const TableComponent = ({ table_data, settable_data, module_id }) => {
  const [modalType, setModalType] = useState("")
  const [show, setShow] = useState(false)
  const [docId, setDocId] = useState("")

  const navigate = useNavigate()

  const { checkAccess, permissions } = usePermissionData()

  document.title = "Document Master | Peacock Accountants Limited"

  const handleStatus = async (status, id) => {
    try {
      if (status) {
        const response = await axiosbaseurl.patch(
          `/document-master/${id}/status`,
          { status }
        )
        if (response.data.success) {
          settable_data(prev =>
            setUpdatedData(
              prev,
              response.data.data || response.data.status,
              "edit",
              "Status "
            )
          )
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async id => {
    try {
      const response = await axiosbaseurl.delete(`/document-master/${id}`)
      if (response.data.success)
        settable_data(prev =>
          setUpdatedData(
            prev,
            response.data.data || response.data.status,
            "delete"
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: " text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Document Name",
        accessor: "documentName",
        disableFilters: true,
        filterable: true,
        className: " text-center",
      },
      {
        Header: "Description",
        accessor: "documentDescription",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <span>
              {cellProps.row.original?.documentDescription
                ? cellProps.row.original?.documentDescription
                : "N/A"}
            </span>
          )
        },
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        className: " text-center",
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </span>
          )
        },
      },
      {
        Header: "Status",
        disableSort: true,
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">
              <select
                onChange={e =>
                  handleStatus(e.target.value, cellProps.row.original.id)
                }
                disabled={!checkAccess(module_id, "edit")}
                className={`badge fs-6 border-0 status_select_dropdown 
                                    bg-${cellProps.row.original.status == "Active"
                    ? "green"
                    : "danger"
                  }`}
                value={cellProps.row.original.status}
              >
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
              </select>
            </div>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: "col-2 text-center",
        Cell: cellProps => {
          return (
            <div>
              {checkAccess(module_id, "edit") && (
                <button
                  onClick={() => {
                    setDocId(cellProps.row.original.id)
                    setShow(true)
                    setModalType("edit")
                  }}
                  className="btn btn-success bg-green  btn-sm me-2"
                >
                  <i className="fas fa-pen me-1"></i> Edit
                </button>
              )}
              {/* {checkAccess(module_id, "remove") && (
                <button
                  onClick={() =>
                    deleteNow(() => handleDelete(cellProps.row.original.id))
                  }
                  className="btn btn-danger btn-sm ml-10"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              )} */}
            </div>
          )
        },
      },
    ],
    [permissions]
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>

        <CommonTable
          columns={columns}
          data={data}
          heading={"Documents"}
        >
          <div>
            {checkAccess(module_id, "add") && (
              <button
                onClick={() => {
                  setModalType("add")
                  setShow(true)
                }}
                className="btn btn-primary bg-blue ms-3"
              >
                <i className="fas fa-plus me-2"></i>
                Add Document
              </button>
            )}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        <AddDocumentMaster
          show={show}
          setShow={setShow}
          type={modalType}
          settable_data={settable_data}
          docId={docId}
          setDocId={setDocId}
        />
      </PermittedComponent>
    </>
  )
}

export default AllDocumentMaster
